import { render, staticRenderFns } from "./AppBottomMenu.vue?vue&type=template&id=6592e5d2&"
import script from "./AppBottomMenu.vue?vue&type=script&lang=ts&"
export * from "./AppBottomMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports